import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, Badge, Modal, Form, Label, Input, UncontrolledTooltip, Button } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import SPMap from './Maps/SPMap';

    const SamplingPoints = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_sp, setmodal_sp] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [spList, setSpList] = useState([]);
        const [sp, setSp] = useState(null);
        const [districts, setDistricts] = useState([])

        const [id, setId] = useState('')
        const [spName, setSPName] = useState('')
        const [coordinates, setCoordinates] = useState('')
        const [spType, setSPType] = useState('')
        const [spFrequency, setSPFrequency] = useState('')
        const [spStatus, setSPStatus] = useState('')
        const [spDistrict, setSPDistrict] = useState('')

        const [isloading, setIsloading] = useState(false);

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_sp = () => {
        setmodal_sp(!modal_sp);
        removeBodyCss();
        }

        const fetchData = () => {
          setIsloading(true)
          axios.get(url.SAMPLINGPOINTS, Config).then((r)=>{ setSpList(r.data); setIsloading(false) }).catch((e)=>{  console.log(e); setIsloading(false) });
          axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
            setDistricts(r.data)
          }).catch((e)=>{  
            console.log(e);
          });
        }
        
        useEffect(() => {
          fetchData();
        },[]);

        const handleAddSP = () => {  
          if (isEdit) {
                const data = {
                    "id"            : id, 
                    "name"          : spName,
                    "cordinates"    : coordinates,
                    "district"      : spDistrict,
                    "type"          : spType,
                    "frequency"     : spFrequency,
                    "status"        : spStatus,
                    "action"        : "update"
                }
                axios.post(url.SAMPLINGPOINTS, JSON.stringify(data), Config)
                .then((r)=>{
                  if(r.data.status == '0'){
                    toastr.error(r.data.message); 
                  }else{
                    toastr.success(r.data.message); 
                    fetchData();
                    tog_sp();
                  }
                })
                .catch((e)=>{
                  console.log(e);
                });
          }else{
                const data = {
                  "name"          : spName,
                  "cordinates"    : coordinates,
                  "district"      : spDistrict,
                  "type"          : spType,
                  "frequency"     : spFrequency,
                  "status"        : spStatus,
                  "action"        : "add"
                }
                axios.post(url.SAMPLINGPOINTS, JSON.stringify(data), Config)
                .then((r)=>{
                  if(r.data.status == '0'){
                    toastr.error(r.data.message); 
                  }else{
                    toastr.success(r.data.message); 
                    fetchData();
                    tog_sp();
                  }
                })
                .catch((e)=>{
                  console.log(e);
                });
          }
        }
        
        const handleClickEdit = (row) => {
          tog_sp(); 
          setIsEdit(true); 
          setId(row.id)
          setSPName(row.name)
          setCoordinates(row.cordinates)
          setSPDistrict(row.districtId)
          setSPType(row.type)
          setSPFrequency(row.frequency)
          setSPStatus(row.status)

        }

        const handleClickAdd = () => {
          
          tog_sp(); 
          setIsEdit(false);
          setSp(null) 
          
        }

        const { SearchBar } = Search;
        const columns = [
        {
          dataField: 'id',
          text: 'ID',
          sort: true
        },
        {
          dataField: 'name',
          text: 'Sampling Point',
          sort: true
        }
        ,

        {
          dataField: 'district',
          text: 'District',
          sort: true
        },
        {
          dataField: 'type',
          text: 'Category',
          sort: true
        },
        {
          dataField: 'frequency',
          text: 'Frequency',
          sort: true
        },
        {
            dataField: 'status',
            text: '',
            sort: true,
            formatter: statusFormatter
          },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'asc'
        }];
        function statusFormatter(cellContent, row) {
          if (row.status == "Active") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
              <Button
                type="button"
                color="info"
                onClick={() => { handleClickEdit(row); }}
                className="btn-sm btn-rounded">
                Details
              </Button>
          </>
          )
        }

        return (
            <>
              <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Sampling Points | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Modal
                                  isOpen={modal_sp}
                                  toggle={() => {
                                    tog_sp();
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Sampling Point ': 'Add Sampling Point' }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_sp(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <Form>
                          
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Name
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control" 
                                          placeholder="Tank A"
                                          value={spName}
                                          onChange={(e)=>setSPName(e.target.value)}
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-firstname-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                       District
                                      </Label>
                                      <Col sm={12}>
                                        <select className="form-select" 
                                          value={spDistrict}
                                          onChange={(e)=>setSPDistrict(e.target.value)} >
                                            <option value=""></option>
                                            {districts.map((d,k)=>(
                                              <option key={k} value={d.id}>{d.name}</option>
                                            ))}
                                            
                                          </select>
                                      </Col>
                                    </div>       
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Cordinates
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control"
                                          value={coordinates}
                                          onChange={(e)=>setCoordinates(e.target.value)}
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-firstname-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                       Nature Of Sampling Point
                                      </Label>
                                      <Col sm={12}>
                                        <select className="form-select" 
                                          value={spType}
                                          onChange={(e)=>setSPType(e.target.value)} >
                                            <option value=""></option>
                                            <option value="Raw Water">Raw Water</option>
                                            <option value="Final Water">Final Water</option>
                                            <option value="Reservoir">Reservoir</option>
                                            <option value="Network/Distribution">Network/Distribution</option>
                                          </select>
                                      </Col>
                                    </div>                                
                                    
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-firstname-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                       Sampling Frequency
                                      </Label>
                                      <Col sm={12}>
                                        <select className="form-select"
                                          value={spFrequency}
                                          onChange={(e)=>setSPFrequency(e.target.value)}>
                                            <option value=""></option>
                                            <option value="Daily">Daily</option>
                                            <option value="Weekly">Weekly</option>
                                            <option value="Monthly">Monthly</option>
                                            <option value="Quarterly">Quarterly</option>
                                            <option value="Annually">Annually</option>
                                          </select>
                                      </Col>
                                    </div>
                                    {(isEdit == true) && (
                                        <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-firstname-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                       Status
                                      </Label>
                                      <Col sm={12}>
                                        <select className="form-select"
                                          value={spStatus}
                                          onChange={(e)=>setSPStatus(e.target.value)} >
                                            <option value=""></option>
                                            <option value="Active">Active</option>
                                            <option value="Deactivated">Deactivated</option>
                                          </select>
                                      </Col>
                                    </div>
                                    )}
                                    </Form>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        tog_sp();
                                      }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick = {()=>{handleAddSP()}}
                                    >
                                      Save...
                                    </button>
                                  </div>
                                </Modal>
                        
                        
                        <Row>
               

                            <Col lg="9">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Sampling Points</h5>
                                <CardBody>
                             

                                {spList && (spList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ spList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                           

                                            <Row className='mb-5'>
                                                  <Col lg={8} className='mb-2'>
                                                    <div  className="rounded bg-light d-grid gap-2">
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn"
                                                        onClick = {()=>{tog_sp()}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add sampling poit
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ spList } 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {spList && (spList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No Sampling Point Set</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                            <Col lg="3">
                            <Card>
                              
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">LOCATION</h5>
                                
                                 <SPMap/>
                            </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default SamplingPoints;